import { HttpErrorResponse } from '@angular/common/http';

import { ApiErrorResponse } from './models';

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof HttpErrorResponse)) {
    return fallback;
  }

  const body = error.error as Partial<ApiErrorResponse> | string | null;
  if (typeof body === 'string' && body.trim()) {
    return body;
  }

  if (body && typeof body === 'object') {
    const fieldErrors = Array.isArray(body.fieldErrors) ? body.fieldErrors : [];
    if (fieldErrors.length > 0) {
      return fieldErrors
        .map((fieldError) => [fieldError.field, fieldError.message].filter(Boolean).join(': '))
        .join(' ');
    }

    if (body.message) {
      return body.message;
    }

    if (body.error) {
      return body.error;
    }
  }

  if (error.status === 403) {
    return 'You do not have permission to perform this action.';
  }

  if (error.status === 401) {
    return 'Your session is missing or expired. Sign in again.';
  }

  return fallback;
}
